import Vue from "vue";
import App from "./App.vue";
import _ from 'lodash';
import router from "@/router";
import store from "@/store";
import http from "@/utils/http";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "normalize.css/normalize.css";
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style
import 'swiper/css/swiper.min.css'

import animated from 'animate.css'

Vue.use(animated)

 
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)


Vue.config.productionTip = false;

Vue.use(ElementUI);

//挂载到vue实例可以直接使用this来访问
Vue.prototype.http = http;

// 点击以外的
Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
